import type { FC } from 'react';

import type { IconProps } from './types';

const Plus: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M512-.001c38.212 0 69.188 30.977 69.188 69.189v373.62h373.62c38.213 0 69.189 30.974 69.189 69.189s-30.976 69.193-69.189 69.193h-373.62v373.62c0 38.213-30.976 69.189-69.188 69.189-38.215 0-69.189-30.976-69.189-69.189V581.19H69.191c-38.212 0-69.189-30.976-69.189-69.193 0-38.215 30.977-69.189 69.189-69.189h373.62V69.188c0-38.212 30.974-69.189 69.189-69.189"
      fill={color}
    />
  </svg>
);

export default Plus;
